import { forwardRef } from "react";
import { InputText } from "primereact/inputtext";

interface LocationFilterInputProps {
  value: string;
  onChange: (value: string) => void;
}

const LocationFilterInput = forwardRef<HTMLInputElement, LocationFilterInputProps>(({ value, onChange }, ref) => {
  return <InputText ref={ref} className="w-full" placeholder="Cauta locatie" value={value} onChange={(e) => onChange(e.target.value)} />;
});

export default LocationFilterInput;
